import { MonthYearString } from 'types/MonthYearString';

export const createConditionedStockCollapseMetaDataListIndex = (monthYearString: MonthYearString): string => {
  return `inventory_form_${monthYearString.month}_${monthYearString.year}`;
};
